import { Tag, Clock, TrendingDown } from 'lucide-react';

export default function Promotions() {
  const promotions = [
    {
      id: 1,
      title: 'Скидка 10% на икру',
      description: 'При покупке икры от 5000 рублей - скидка 10%',
      image: 'https://images.unsplash.com/photo-1757961048219-df1bbd0be167',
      discount: '10%',
      validUntil: '31.12.2025'
    },
    {
      id: 2,
      title: 'Бесплатная доставка',
      description: 'При заказе от 10000 рублей доставка бесплатно',
      image: 'https://images.unsplash.com/photo-1739991017889-009e4fc9cdc6',
      discount: 'Бесплатно',
      validUntil: 'Постоянно'
    },
    {
      id: 3,
      title: 'Бонусная программа',
      description: 'Зарегистрируйтесь и получите 100 бонусных баллов. 5% кэшбэк с каждой покупки',
      image: 'https://images.unsplash.com/photo-1626727873980-fa047e09507f',
      discount: '5%',
      validUntil: 'Постоянно'
    },
    {
      id: 4,
      title: 'Промокод WELCOME10',
      description: 'Скидка 10% на первый заказ по промокоду',
      image: 'https://images.unsplash.com/photo-1648431529663-8ae9606630c0',
      discount: '10%',
      validUntil: '31.12.2025'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }} data-testid="promotions-title">
            Актуальные акции
          </h1>
          <p className="text-xl text-gray-600">Не пропустите выгодные предложения!</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="promotions-grid">
          {promotions.map(promo => (
            <div key={promo.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow" data-testid={`promo-${promo.id}`}>
              <div className="relative h-64">
                <img
                  src={promo.image}
                  alt={promo.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg">
                  -{promo.discount}
                </div>
              </div>
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <Tag className="w-6 h-6 text-sky-600 mr-2" />
                  <h3 className="text-2xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    {promo.title}
                  </h3>
                </div>
                <p className="text-gray-600 mb-6">{promo.description}</p>
                <div className="flex items-center text-sm text-gray-500">
                  <Clock className="w-4 h-4 mr-2" />
                  <span>Действует до: {promo.validUntil}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}